import { CommonIn, CommonOut } from "./common";

export class ClipIn extends CommonIn {
    constructor(from, to, duration, easing, params) {
        super(from, to, duration, easing, params), this.keys = [ "clipRange" ], this.from = {
            clipRange: 0
        };
    }
    onFirstRun() {
        var _a;
        super.onFirstRun();
        const {clipDimension: clipDimension} = (null === (_a = this.params) || void 0 === _a ? void 0 : _a.options) || {};
        clipDimension && (this.target.attribute.clipRangeByDimension = clipDimension);
    }
}

export class ClipOut extends CommonOut {
    constructor(from, to, duration, easing, params) {
        super(from, to, duration, easing, params), this.keys = [ "clipRange" ];
    }
}
//# sourceMappingURL=clip.js.map